import { useApi, createApiHook } from "../utils/apiUtils";

const useRelateQuestionnaires = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const relateQuestionnaires = async ({ appId, questionnaireIds }) => {
    if (!appId || !questionnaireIds || questionnaireIds.length === 0) return false;
    startLoading();
    const response = await apiPost(`/aplicaciones/${appId}/relate_questionnaires`, "Error al relacionar los cuestionarios", {
      questionnaire_ids: questionnaireIds,
    });
    setResponse(response);
    return !response?.error;
  };

  return { relateQuestionnaires, data, error, loading };
};

export default useRelateQuestionnaires;
